import test_entry_config from "../config/test_entry_config.json";
import { cloneDeep } from "lodash";
import {
  getCumulativeSum,
  getProbabilityPercentOfTheValue,
  getRingNoOfElement,
  removeMultiple,
} from "./TestEntryUtil";

export function calculateVFILinear(md, normalValues) {
  // y = (100/max(normal_val))x + 100
  const maxNormal = Math.max.apply(null, normalValues) + 1;
  const scaledx = (100 * md) / maxNormal;
  const vfi = scaledx + 100;
  const rounded = Math.round(vfi);
  return Math.ceil(Math.min(100, rounded));
}

export function calculateVfi(
  testType,
  eye,
  thresholdValues,
  npdRawValues,
  normalValues,
  md,
  percentagesStr,
) {
  const threshSum = thresholdValues.reduce((a, b) => a + b, 0);
  if (threshSum < 4) {
    return 0;
  }
  if (md >= 3) {
    return 100;
  }
  if (md <= -20) {
    return calculateVFILinear(md, normalValues);
  }
  const config = cloneDeep(test_entry_config);

  const indicesToBecome24 = test_entry_config["IndicesToBecome24-2"][testType][eye];
  const newThr = [];
  const newPd = [];
  const newNewNormals = [];
  if (indicesToBecome24.length != 0) {
    indicesToBecome24.forEach((i) => {
      newThr.push(thresholdValues[i]);
      newPd.push(npdRawValues[i]);
      newNewNormals.push(normalValues[i]);
    });

    npdRawValues = newPd;
    thresholdValues = newThr;
    normalValues = newNewNormals;
    testType = "24-2";
  }

  const statisticsValueBorders = config["statisticsValueBorders"];
  const standardDeviations = test_entry_config["standardDeviations"][testType][eye];
  const vfiInnerRingWeights = config["vfiInnerRingWeights"];

  const testConfig = config["thresholdMap"][testType][eye];
  const elementsInRow = testConfig["elementsInRow"];
  const middleRow = testConfig["middleRow"];
  const middleCol = testConfig["middleCol"];
  const startIndexForElementsInRow = testConfig["startIndexForElementsInRow"];
  const emptyCellsIndex = testConfig["emptyCellsIndex"];

  const cumulativeElementsInRow = getCumulativeSum(elementsInRow);
  cumulativeElementsInRow.unshift(0);

  const valuesWithoutRingWeights = thresholdValues.map((v, i) => {
    return calculateVfiPercentage(
      npdRawValues[i],
      v,
      standardDeviations[i],
      normalValues[i],
      percentagesStr,
    );
  });

  function calculateVfiPercentage(ps, thresholdVal, standardDev, normalVal, percentagesStr) {
    const p = getProbabilityPercentOfTheValue(0, ps, standardDev, percentagesStr);
    const percents = statisticsValueBorders[percentagesStr];
    if (p < percents[0]) {
      return 0;
    } else if (p >= percents[3]) {
      return 100;
    } else {
      return 100 - Math.abs(((normalVal - thresholdVal) * 100) / normalVal);
      // return 100 - (Math.abs(totalDev) / (thresholdVal - totalDev)) * 100;
    }
  }

  const weightedValues = valuesWithoutRingWeights.map((v, i) => {
    const ring = getRingNoOfElement(
      cumulativeElementsInRow,
      middleRow,
      middleCol,
      cumulativeElementsInRow,
      i,
      startIndexForElementsInRow,
    );
    const weight = ring - 1 >= vfiInnerRingWeights.length ? -1 : vfiInnerRingWeights[ring - 1];
    return weight * v;
  });
  let filteredValues = removeMultiple(weightedValues, emptyCellsIndex);
  filteredValues = filteredValues.filter((v) => v >= 0);
  const meanOfVfi =
    filteredValues.reduce((a, b) => a + b, 0) /
    (filteredValues.length > 0 ? filteredValues.length : 1);
  return Math.ceil(Math.min(100, meanOfVfi));
}
